"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FounderPortraitIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="founder-portrait-introduction" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className="grid gap-12 items-center transition-all duration-700 ease-out opacity-100 translate-y-0 ![padding:50px_0px_8px_0px] !bg-[hsl(0,0%,100%)] lg:grid-cols-2 lg:gap-16">
          {}
          <div className="relative aspect-[3/4] w-full overflow-hidden rounded-xl bg-muted shadow-lg lg:aspect-square">
            <img src="https://humble-drake.10web.cloud/wp-content/uploads/2026/02/6-3.jpg" alt="Founder Portrait" className="h-full w-full object-cover object-center transition-transform duration-500 hover:scale-105" />
          </div>

          {}
          <div className="flex flex-col items-start space-y-6">
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">Telling the Exciting <br />Story of Israel</h2>
            <p className="text-muted-foreground leading-relaxed !text-lg !w-[580px]">My name is Chen (pronounced ‘Ken’), a medical marketer turned tour guide. Over the last two decades as a medical marketer and communicator, I’ve helped numerous companies craft more compelling narratives around their technology. I am thrilled these stories established impactful global partnerships and raised hundreds of millions of dollars in funding. Now, I’m using my storytelling skills to bring to you the history, culture, and beauty of Israel to life. My promise is that you’ll see come away with a new understanding of this incredible place I call home.</p>
            
            
            <div className="pt-4">
              <Link to="/about" className="inline-block">
                
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}